import sortBy from 'lodash/sortBy';
import type { Nullable } from '@direct-frontend/stdlib';
import { type ImageInfo } from '../../../api/image';

const MAX_SRC_SIZE = 100_000;

export function getAdaptiveImageSources(
    image: Nullable<Pick<ImageInfo, 'file_path'> & { sizes?: ImageInfo['sizes'] }>,
    aliases: string[] = (image?.sizes ?? []).map((item) => item.alias)
): [string, number][] {
    if (!image) {
        return [];
    }

    const originalSource = image.file_path;
    const sources: [string, number][] = (image.sizes ?? [])
        .filter((size) => aliases.includes(size.alias))
        .map((size) => [originalSource.replace(/orig$/, size.alias), size.width || MAX_SRC_SIZE]);

    return sources.length ? sortBy(sources, '1') : [[originalSource, MAX_SRC_SIZE]];
}
